import { createRouter, createWebHistory, RouteRecordRaw, RouterView } from 'vue-router'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'

import axios from 'axios'
const url = import.meta.env.VITE_API_URL

const normalizathor = (param) => {
  return param
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
}

const heimdall = async (param) => {
  let inform = false

  try {
    const token = localStorage.getItem('token')
    const resp = await axios.get(url + '/usuariolist/mypermissions/', {
      headers: { Authorization: 'Bearer ' + token },
    })

    const normalizado = normalizathor(param)

    inform = resp.data.some((permission) => {
      const normalizedPermission = normalizathor(permission.name)
      return normalizedPermission.includes(normalizado)
    })
  } catch (error) {
    inform = false
  }

  return inform
}

const routes: Array<RouteRecordRaw> = [
  {
    // Instagram OAuth callback must be reachable directly by the provider.
    // Keep this route public and before the catch-all redirect.
    name: 'instagram-callback',
    path: '/instagram/callback',
    component: () => import('../pages/instagram/InstagramCallback.vue'),
  },

  {
    // Whatsapp callback must be reachable directly by the provider.
    // Keep this route public and before the catch-all redirect.
    name: 'whatsapp-callback',
    path: '/whatsapp/callback',
    component: () => import('../pages/whatsapp/WhatsappCallback.vue'),
  },

  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'login' },
  },
  {
    name: 'admin',
    path: '/', // /admin
    component: AppLayout,
    redirect: { name: 'login' },
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        component: () => import('../pages/admin/dashboard/Dashboard.vue'),
      },
      {
        name: 'crm',
        path: 'crm',
        // component: () => import('../pages/crm/Chat.vue'),
        redirect: { name: 'chat' },
        component: RouterView,
        children: [
          {
            name: 'chat',
            path: '',
            component: () => import('../pages/crm/Chat.vue'),
          },
          {
            name: 'crm-history',
            path: 'history',
            component: () => import('../pages/contato/Historico.vue'),
          },
        ],
      },
      {
        name: 'agenda',
        path: 'agenda/:modo?', // 'mes' | 'semana' | 'dia'
        component: () => import('../pages/agenda/AgendaPage.vue'),
        props: true,
      },
      {
        name: 'tarefas',
        path: 'tarefas',
        component: () => import('../pages/tarefa/TarefasPage.vue'),
        meta: { title: 'Tarefas' },
      },
      {
        name: 'oportunidades',
        path: 'oportunidades',
        component: () => import('../pages/oportunidades/Oportunidades.vue'),
        meta: {
          title: 'Oportunidades',
          permission: 'view lead',
        },
      },
      {
        name: 'demos',
        path: 'demo',
        children: [
          {
            name: 'lead-contact-demo',
            path: 'lead-contact',
            component: () => import('../pages/demo/LeadContactDemo.vue'),
            meta: {
              title: 'Demonstração: Busca de Leads e Contatos',
              permission: 'ver demo leads',
            },
          },
          {
            name: 'lead-test',
            path: 'lead-test',
            component: () => import('../pages/demo/LeadTest.vue'),
            meta: {
              title: 'Demonstração: Teste de Leads',
              permission: 'ver demo testes',
            },
          },
        ],
      },
      // {
      //   name: 'lead-contact-demo',
      //   path: 'demo/lead-contact',
      //   component: () => import('../pages/demo/LeadContactDemo.vue'),
      //   meta: {
      //     title: 'Demonstração: Busca de Leads e Contatos',
      //     // ✅ SEGURO: Usa sistema de permissões do backend
      //     // 🔧 CONFIGURAÇÃO: Admin define no painel administrativo quem tem esta permissão
      //     permission: 'ver demo leads',
      //   },
      // },
      // {
      //   name: 'lead-test',
      //   path: 'demo/lead-test',
      //   component: () => import('../pages/demo/LeadTest.vue'),
      //   meta: {
      //     title: 'Demonstração LeadTest',
      //     // ✅ SEGURO: Usa sistema de permissões do backend
      //     // 🔧 CONFIGURAÇÃO: Admin define no painel administrativo quem tem esta permissão
      //     permission: 'ver demo testes',
      //   },
      // },
      {
        name: 'businessHour',
        path: 'businessHour',
        redirect: { name: 'bh_list' },
        children: [
          {
            name: 'bh_list',
            path: '',
            component: () => import('../pages/business/BusinessHourTable.vue'),
          },
          {
            name: 'bh_create',
            path: 'create',
            component: () => import('../pages/business/BusinessHourCreate.vue'),
          },
        ],
      },
      {
        name: 'template',
        path: 'template',
        component: RouterView,
        redirect: { name: 'temp_list' },
        children: [
          {
            name: 'temp_list',
            path: '',
            component: () => import('../pages/templates/TemplateTable.vue'),
          },
          {
            name: 'temp_create',
            path: 'create',
            component: () => import('../pages/templates/TemplateCreate.vue'),
          },
          {
            name: 'temp_edit',
            path: 'edit/:slug',
            component: () => import('../pages/templates/TemplateEdit.vue'),
          },
        ],
      },
      {
        name: 'painel',
        path: 'painel',
        component: () => import('../pages/crm/Kanban.vue'),
      },
      {
        name: 'settings',
        path: 'settings',
        component: () => import('../pages/settings/Settings.vue'),
      },
      {
        name: 'usuarioLogado',
        path: 'me',
        redirect: { name: 'me_list' },
        children: [
          {
            name: 'me_list',
            path: '',
            component: () => import('../pages/usuarios/UsuarioLogado.vue'),
          },
          {
            name: 'me_edit',
            path: 'edit/:slug',
            component: () => import('../pages/usuarios/UsuarioEdit.vue'),
          },
        ],
      },
      {
        name: 'cliente',
        path: 'cliente',
        redirect: { name: 'c_list' },
        children: [
          {
            name: 'c_list',
            path: '',
            component: () => import('../pages/clientes/ClientesTable.vue'),
            meta: { permission: 'view cliente' },
          },
          {
            name: 'c_create',
            path: 'create',
            component: () => import('../pages/clientes/ClientesCreate.vue'),
            meta: { permission: 'add cliente' },
          },
          {
            name: 'c_edit',
            path: 'edit/:slug',
            component: () => import('../pages/clientes/ClienteEdit.vue'),
            meta: { permission: 'change cliente' },
          },
          {
            name: 'c_doc',
            path: 'docs/:slug',
            component: () => import('../pages/clientes/ClienteDoc.vue'),
            meta: { permission: 'add documento cliente' },
          },
        ],
      },
      {
        name: 'veiculo',
        path: 'veiculo',
        children: [
          {
            name: 'v_list',
            path: '',
            component: () => import('../pages/veiculos/VeiculosTable.vue'),
            meta: { permission: 'view veículo' },
          },
          {
            name: 'v_create',
            path: 'create',
            component: () => import('../pages/veiculos/VeiculosCreate.vue'),
            meta: { permission: 'add veículo' },
          },
          {
            name: 'v_edit',
            path: 'edit/:slug',
            component: () => import('../pages/veiculos/VeiculosEdit.vue'),
            meta: { permission: 'change veículo' },
          },
          /* {
            name: 'baixados',
            path: 'baixados',
            component: () => import('../pages/payments/PaymentsPage.vue'),
            meta: { permission: 'view veículo' },
          }, */
          {
            name: 'v_doc',
            path: 'docs/:slug',
            component: () => import('../pages/veiculos/VeiculosDoc.vue'),
            meta: { permission: 'view documento veículo' },
          },
          {
            name: 'v_pho',
            path: 'fotos/:slug',
            component: () => import('../pages/veiculos/VeiculosPhotos.vue'),
            meta: { permission: 'view foto veículo' },
          },
        ],
      },
      {
        name: 'empresa',
        path: 'empresa',
        children: [
          {
            name: 'e_list',
            path: '',
            component: () => import('../pages/empresa/EmpresaPage.vue'),
            meta: { permission: 'view empresa' },
          },
          {
            name: 'e_edit',
            path: 'edit/:slug',
            component: () => import('../pages/empresa/EmpresaEdit.vue'),
            meta: { permission: 'change empresa' },
          },
          {
            name: 'e_fil',
            path: 'files/:slug',
            component: () => import('../pages/empresa/EmpresaFiles.vue'),
            meta: { permission: 'change empresa' },
          },
        ],
      },
      {
        name: 'venda',
        path: 'venda',
        children: [
          {
            name: 've_list',
            path: '',
            component: () => import('../pages/vendas/VendaTable.vue'),
            meta: { permission: 'view venda' },
          },
          {
            name: 've_create',
            path: 'create',
            component: () => import('../pages/vendas/VendaCreate.vue'),
            meta: { permission: 'add venda' },
          },
          {
            name: 've_edit',
            path: 'edit/:slug',
            component: () => import('../pages/vendas/VendaEdit.vue'),
            meta: { permission: 'change venda' },
          },
        ],
      },
      {
        name: 'usuario',
        path: 'usuario',
        children: [
          {
            name: 'u_list',
            path: '',
            component: () => import('../pages/usuarios/UsuarioTable.vue'),
            meta: { permission: 'view usuario' },
          },
          {
            name: 'u_create',
            path: 'create',
            component: () => import('../pages/usuarios/UsuarioCreate.vue'),
            meta: { permission: 'add usuario' },
          },
          {
            name: 'u_edit',
            path: 'edit/:slug',
            component: () => import('../pages/usuarios/UsuarioEdit.vue'),
            meta: { permission: 'change usuario' },
          },
          {
            name: 'u_perm',
            path: 'permissions/:slug',
            component: () => import('../pages/usuarios/UsuarioPermission.vue'),
            meta: { permission: 'conceder permissoes' },
          },
        ],
      },
      {
        name: 'relatorio',
        path: 'relatorio',
        children: [
          {
            name: 'rel_procuracao',
            path: 'procuracao',
            component: () => import('../pages/relatorios/Procuracao.vue'),
          },
        ],
      },
      {
        name: 'procurador',
        path: 'procurador',
        children: [
          {
            name: 'proc_list',
            path: '',
            component: () => import('../pages/clientes/ProcuradorTable.vue'),
            meta: { permission: 'view empresa' },
          },
          {
            name: 'proc_create',
            path: 'create',
            component: () => import('../pages/clientes/ProcuradorCreate.vue'),
            meta: { permission: 'view empresa' },
          },
          {
            name: 'proc_edit',
            path: 'edit/:slug',
            component: () => import('../pages/clientes/ProcuradorEdit.vue'),
            meta: { permission: 'view empresa' },
          },
        ],
      },
      {
        name: 'negociacao',
        path: 'negociacao',
        redirect: { name: 'propostas-list' },
        meta: {
          breadcrumb: 'Negociações',
        },
        children: [
          {
            name: 'propostas-list',
            path: '',
            component: () => import('../pages/negociacao/PropostaList.vue'),
            meta: {
              breadcrumb: 'Propostas',
              icon: 'handshake',
              title: 'Negociações - Propostas',
            },
          },
          {
            name: 'proposta-create',
            path: 'novo',
            component: () => import('../pages/negociacao/PropostaForm.vue'),
            meta: {
              breadcrumb: 'Nova Proposta',
              parent: 'propostas-list',
              title: 'Nova Proposta',
            },
          },
          {
            name: 'proposta-detail',
            path: ':slug',
            component: () => import('../pages/negociacao/PropostaDetail.vue'),
            meta: {
              breadcrumb: 'Detalhes',
              parent: 'propostas-list',
              title: 'Detalhes da Proposta',
            },
          },
          {
            name: 'proposta-edit',
            path: ':slug/editar',
            component: () => import('../pages/negociacao/PropostaForm.vue'),
            meta: {
              breadcrumb: 'Editar',
              parent: 'propostas-list',
              title: 'Editar Proposta',
            },
          },
          {
            name: 'proposta-itens',
            path: ':slug/itens',
            component: () => import('../pages/negociacao/PropostaItens.vue'),
            meta: {
              breadcrumb: 'Itens',
              parent: 'propostas-list',
              title: 'Veículos da Proposta',
            },
          },
          {
            name: 'propostas-kanban',
            path: 'kanban',
            component: () => import('../pages/negociacao/PropostaKanban2.vue'),
            meta: {
              breadcrumb: 'Kanban',
              parent: 'propostas-list',
              icon: 'view_kanban',
              title: 'Kanban de Propostas',
            },
          },
          {
            name: 'propostas-dashboard',
            path: 'dashboard',
            component: () => import('../pages/negociacao/PropostaDashboard.vue'),
            meta: {
              breadcrumb: 'Dashboard',
              parent: 'propostas-list',
              icon: 'dashboard',
              title: 'Dashboard de Negociações',
            },
          },
        ],
      },
      {
        name: 'contato',
        path: 'contato',
        redirect: { name: 'cont_list' },
        children: [
          {
            name: 'cont_list',
            path: '',
            component: () => import('../pages/contato/ContatoTable.vue'),
          },
          {
            name: 'cont_create',
            path: 'create',
            component: () => import('../pages/contato/ContatoCreate.vue'),
          },
          {
            name: 'cont_edit',
            path: 'edit/:slug',
            component: () => import('../pages/contato/ContatoEdit.vue'),
          },
          {
            name: 'tags-list',
            path: 'tags',
            component: () => import('../pages/tags/TagsTable.vue'),
          },
          {
            name: 'tags-create',
            path: 'tags/create',
            component: () => import('../pages/tags/TagsForm.vue'),
          },
          {
            name: 'tags-edit',
            path: 'tags/edit/:id',
            component: () => import('../pages/tags/TagsForm.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        name: 'recover-password',
        path: 'recover-password',
        component: () => import('../pages/auth/RecoverPassword.vue'),
      },
      {
        name: 'recover-password-email',
        path: 'recover-password-email',
        component: () => import('../pages/auth/CheckTheEmail.vue'),
      },
      {
        name: 'signup',
        path: 'signup',
        component: () => import('../pages/auth/Signup.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
  {
    name: '403',
    path: '/forbidden',
    component: () => import('../pages/Forbidden.vue'),
  },
  {
    name: 'verified',
    path: '/verify/:token',
    component: () => import('../pages/Verified.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

router.beforeEach(async (to, from, next) => {
  if (to.name === 'u_create' && localStorage.getItem('addU') !== 'true') {
    return next('/forbidden')
  }

  // ✅ Verificação de permissões (sistema existente melhorado)
  const requiredPermission = to.meta.permission
  if (requiredPermission) {
    try {
      const hasPermission = await heimdall(requiredPermission)
      if (!hasPermission) {
        console.warn(`Acesso negado: permissão '${requiredPermission}' necessária`)
        return next('/forbidden')
      }
    } catch (error) {
      console.error('Erro ao verificar permissões:', error)
      return next('/forbidden')
    }
  }

  return next()
})

export default router
